export default {
  addUser: {
    server: '/users',
    method: 'post',
  },
  getUsers: {
    server: '/users',
    method: 'get',
  },
  getUser: {
    server: '/users/{userId}',
    method: 'get',
  },
  deleteUser: {
    server: '/users/{userId}',
    method: 'delete',
  },
  putUser: {
    server: '/users/{userId}',
    method: 'put',
  },
  patchUserDisable: {
    server: '/users/{userId}/disable',
    method: 'patch',
  },
  getUserRoles: {
    server: '/users/{userId}/roles',
    method: 'get',
  },
  getUserUserGroups: {
    server: '/users/{userId}/user-groups',
    method: 'get',
  },
  postUserProfile: {
    server: '/users/{userId}/profile',
    method: 'post',
  },
  postUserPassword: {
    server: '/users/{userId}/password',
    method: 'post',
  },
};
